import { useAdminContext } from '@/contexts/AdminContext';
import { MessageType } from '@common/api/agentService';
import Icon from '@common/components/Icon';
import { Button } from '@common/index';
import React from 'react';
import styles from './Artifact.module.scss';

interface ArtifactProps {
    message: MessageType;
}

export const Created: React.FC<ArtifactProps> = ({ message }) => {
    const { chat: { setCurrentResultId } } = useAdminContext();
    const title = (message as any)?.title || 'Result';
    const artifactId = (message as any)?.artifact_id as string;

    const onViewDetails = () => {
        setCurrentResultId(artifactId);
    };

    return (
        <div className={styles.artifactCard}>
            <div className={styles.left}>
                <Icon
                    size={36}
                    name="artifact"
                    color="white"
                    style={{
                        backgroundColor: '#6C5DD3', borderRadius: 8, padding: 8
                    }}
                />
                <div className={styles.title} title={title}>{title}</div>
            </div>
            <Button variant="solid" onClick={onViewDetails}>View details</Button>
        </div>
    );
};


